export class ImportCountResult {
    count: number = 0;
}
